import matchStart from './match_start_select2';

// When creating/editing a recipe, sum amounts of all ingredients and show total
const setTotalRecipeAmount = function () {
  let totalAmount = 0;
  $('.ing-amount:visible').each(function () {
    const amount = $(this).val();
    if (!Number.isNaN(amount) && amount.length !== 0) {
      totalAmount += parseFloat(amount);
    }
  });
  $('.ing-total-amount').text(totalAmount.toFixed(2));
};

document.addEventListener('turbolinks:load', function () {
  // Update total amount when typing or removing ingredient
  $('#recipe_ingredients_edit_table').on(
    'keyup',
    'input',
    setTotalRecipeAmount
  );
  $('#recipe_ingredients_edit_table').on('cocoon:after-remove', function () {
    setTotalRecipeAmount();
  });

  $('#recipe_ingredients_edit_table, #parameter_list_edit_table').on(
    'cocoon:after-insert',
    function () {
      //  Initialize select2 after ingredient insert
      $('select').select2({
        width: '100%',
      });
    }
  );

  $('.js-product-select').select2({
    width: '100%',
    matcher: matchStart,
  });
});
